import React from 'react'
import {FaSearch} from 'react-icons/fa'

// Components
import Search from './Search.styled'

const SearchComponent = (props) => {
  const {
    value,
    handleInputChange,
    handleSearch,
  } = props

  return (
    <Search onSubmit={handleSearch}>
      <Search.InputWrapper>
        <Search.Input
          placeholder='Tìm kiếm...'
          value={value}
          onChange={handleInputChange}
        />
      </Search.InputWrapper>

      <Search.SubmitBtn>
        <FaSearch />
      </Search.SubmitBtn>
    </Search>
  )
}

export default SearchComponent
